<template>
  <div class="container">
    <div class="top">
      <div class="search">
        <el-input
          placeholder="请输入题名、DOI"
          v-model="keyWords"
          @keyup.enter.native="toSearch"
          clearable
        ></el-input>
        <span class="search_img" @click="toSearch"
          ><img src="../../assets/images/search_icon.png"
        /></span>
      </div>
    </div>

    <div class="table-info">
      <el-table
        class="table"
        :data="tableData"
        :cell-style="tableCellStyle"
        :header-cell-style="tableHeaderCellStyle"
        border
        style="width: 100%"
      >
        <el-table-column
          label="时间"
          prop="createTime"
          align="center"
          width="190"
        />
        <el-table-column
          label="文章题名"
          prop="title"
          align="center"
          width="200"
          show-overflow-tooltip
        >
          <template slot-scope="scope" label="操作">
            <span
              class="titlecn"
              @click="toDetail(scope.row)"
              v-html="scope.row.title"
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="DOI" prop="doi" align="center" width="270">
          <template slot-scope="scope" label="操作">
            <span v-html="scope.row.doi"></span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center" width="100">
          <template slot-scope="scope" label="操作">
            <span>{{ getState(scope.row.state) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope" label="操作">
            <div class="actions">
              <el-button
                type="text"
                v-if="scope.row.state == 20"
                @click="download(scope.row)"
                >下载</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
export default {
  name: "MyApply",
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      keyWords: "",
      total: 100,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 修改表格边框颜色
    tableCellStyle() {
      return "border-color: #CCCCCC; ";
    },
    tableHeaderCellStyle() {
      return "border-color: #CCCCCC; color: #666; background:#eee;";
    },
    getState(state) {
      if (state == 10) {
        return "待处理";
      }
      if (state == 20) {
        return "已完成";
      }
    },
    toSearch() {
      this.pageNo = 1;
      this.getList();
    },
    getList() {
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        mixed: this.keyWords,
      };
      this.$http({
        url: "api/v1/deliver/apply/user/list",
        method: "POST",
        data: postBody,
      }).then((res) => {
        this.total = res.total;
        this.tableData = res.rows;
      });
    },
    toDetail(row) {
      let _url = this.$router.resolve({
        path: "/articleDetail",
        query: { sid: row.paperSid },
      });
      window.open(_url.href, "_self");
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    gethttp(val) {
      if (val.indexOf("http") == 0) {
        return true;
      }
    },
    download(row) {
      this.$http({
        url: `/api/v1/deliver/apply/user/gain?sid=${row.sid}`,
        method: "get",
      }).then((res) => {
        window.open(
          baseurl.baseUrl + "/api/v1/deliver/apply/download?uid=" + res.data
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table .el-table__header {
  width: 100% !important;
}
::v-deep .el-table .el-table__body {
  width: 100% !important;
}
.el-table {
  border: 1px solid #cccccc;
}
.container {
  padding: 20px;
  .titlecn {
    cursor: pointer;
    &:hover {
      color: #2d8cf0;
    }
  }
  .top {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .search {
      display: flex;
      align-items: center;
      background: #fff;
      border: 1px solid #cccccc;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        border-radius: 0;
        height: 30px;
        line-height: 30px;
      }
      ::v-deep .el-input__icon {
        line-height: 30px;
      }
      .el-input {
        width: 280px;
      }
      .search_img {
        width: 40px;
        height: 30px;
        background: #2d8cf0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .table-info {
    clear: both;
  }
}
</style>
